import { UserRoleName } from 'models'
import React from 'react'
import { Route, RouteProps } from 'react-router'
import { Redirect } from 'react-router-dom'
import { User } from 'utilities'
import PageWrapper from './PageWrapper'

export interface PrivateRouteProps extends RouteProps {
  notAllowedUserRoleNames?: UserRoleName[]
}

const PrivateRoute = (props: PrivateRouteProps) => {
  const {
    component: Component,
    notAllowedUserRoleNames = [],
    ...rest
  } = props

  return (
    <Route
      {...rest}
      render={componentProps => (
        (User.isAuthenticated() &&
          User.userRoleNames.some(roleName => !notAllowedUserRoleNames.includes(roleName)))
          ? <PageWrapper><Component {...componentProps} /></PageWrapper>
          : <Redirect to={{ pathname: '/login', state: { from: componentProps.location } }} />
      )}
    />
  )
}

export default PrivateRoute
